import { ReactNode } from 'react';

import { cn } from '@/lib/utils';

/**
 * The house status pill (#6713): a rounded tint carrying one short word, the
 * shape every status on the surface already wears. It exists because the same
 * markup was hand-written in three places on the Business page and had drifted
 * to `rounded`, which reads as a box rather than a pill.
 *
 * The colour pair is the caller's, since what a colour means belongs to the
 * value: Tailwind's -100 background over -800 text, as the brand's status
 * pills do.
 */
interface StatusPillProps {
  children: ReactNode;
  /** The colour pair, for example `bg-blue-100 text-blue-800`. */
  className?: string;
  title?: string;
}

export function StatusPill({ children, className, title }: StatusPillProps) {
  return (
    <span
      title={title}
      className={cn('inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium', className)}
    >
      {children}
    </span>
  );
}
